// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uqdngDNUdIL0o2HZownz{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    font-weight: 700;
    color: var(--letter-dark);
    line-height: 20px;
    margin: 16px 0 16px 0;
}

.kwi2k2MShu7eArEJIgXo{
    display: flex;
    justify-content: space-between; 
    align-items: center; 
    flex-direction: row; 
    margin-top: 16px;
    margin-bottom: 32px;
}

.SYh784o9iqPWyGbKEOrD{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 450px;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid black;
}

.L53gj8jh1Rsnadsor949{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    background-color: var(--background-dark);
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/ProvidersPanel/ProviderModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;AAC5C","sourcesContent":[".actionModalTitle{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--letter-dark);\n    line-height: 20px;\n    margin: 16px 0 16px 0;\n}\n\n.confirmationButtons{\n    display: flex;\n    justify-content: space-between; \n    align-items: center; \n    flex-direction: row; \n    margin-top: 16px;\n    margin-bottom: 32px;\n}\n\n.testedNumbersList{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 450px;\n    padding: 8px;\n    box-sizing: border-box;\n    border: 1px solid black;\n}\n\n.labels{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n    background-color: var(--background-dark);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionModalTitle": `uqdngDNUdIL0o2HZownz`,
	"confirmationButtons": `kwi2k2MShu7eArEJIgXo`,
	"testedNumbersList": `SYh784o9iqPWyGbKEOrD`,
	"labels": `L53gj8jh1Rsnadsor949`
};
export default ___CSS_LOADER_EXPORT___;
